<template>
  <nav class="menu" role="menu">
    <a
      :href="links.about"
      :class="this.$route.name === 'about' ? 'active' : false"
      data-nav="about"
      data-order="0"
      data-menu
      :aria-label="translate('ABOUT', $store.state.lang)"
      @click.prevent="$goTo(links.about, 'menu');"
    >
      <Title
        size="big"
        :text="translate('ABOUT', $store.state.lang)"
        data-view="false"
      />
      <Counter class="menu__counter" number="01" />

      <div
        class="menu__line"
      >
        <div class="menu__line__inner menu__line__inner--first" />
        <div class="menu__line__inner menu__line__inner--last" />
      </div>
    </a>

    <a
      :href="links.investimenti"
      :class="this.$route.name === 'projects' ? 'active' : false"
      data-nav="investimenti"
      data-order="1"
      data-menu
      :aria-label="translate('INVESTIMENTI', $store.state.lang)"
      @click.prevent="$goTo(links.investimenti, 'menu');"
    >
      <Title
        size="big"
        :text="translate('INVESTIMENTI', $store.state.lang)"
        data-view="false"
      />
      <Counter class="menu__counter" number="02" />

      <div
        class="menu__line"
      >
        <div class="menu__line__inner menu__line__inner--first" />
        <div class="menu__line__inner menu__line__inner--last" />
      </div>
    </a>

    <a
      :href="links.team"
      :class="this.$route.name === 'people' ? 'active' : false"
      data-nav="team"
      data-order="2"
      data-menu
      :aria-label="translate('TEAM', $store.state.lang)"
      @click.prevent="$goTo(links.team, 'menu');"
    >
      <Title
        size="big"
        :text="translate('TEAM', $store.state.lang)"
        data-view="false"
      />
      <Counter class="menu__counter" number="03" />

      <div
        class="menu__line"
      >
        <div class="menu__line__inner menu__line__inner--first" />
        <div class="menu__line__inner menu__line__inner--last" />
      </div>
    </a>

    <a
      :href="links.contatti"
      :class="this.$route.name === 'contact' ? 'active' : false"
      data-nav="contatti"
      data-order="3"
      data-menu
      :aria-label="translate('CONTATTI', $store.state.lang)"
      @click.prevent="$goTo(links.contatti, 'menu');"
    >
      <Title
        size="big"
        :text="translate('CONTATTI', $store.state.lang)"
        data-view="false"
      />
      <Counter class="menu__counter" number="04" />

      <div
        class="menu__line"
      >
        <div class="menu__line__inner menu__line__inner--first" />
        <div class="menu__line__inner menu__line__inner--last" />
      </div>
    </a>

    <div class="lang" v-if="Object.keys(lang).length > 0">
      <div
        class="lang--it"
        :class="$store.state.lang === 'it' ? 'lang--active' : false"
        style="opacity: 0; transform: translateY(50px)"
      >
        <Breadcrumbs
          :voice="lang.it"
          direction="next"
          trans="lang"
          size="small"
        />
      </div>
      <div
        class="lang--en"
        :class="$store.state.lang === 'en' ? 'lang--active' : false"
        style="opacity: 0; transform: translateY(50px)"
      >
        <Breadcrumbs
          :voice="lang.en"
          direction="prev"
          trans="lang"
          size="small"
        />
      </div>
    </div>

    <div
      class="info__menu"
      @click="toggleInfo"
    >
      <div
        class="info__line"
        style="opacity: 0; transform: translateY(50px)"
      >
        <div class="info__line__inner info__line__inner--first" />
        <div class="info__line__inner info__line__inner--last" />
      </div>
      <Paragraph
        size="small"
        :text="toggle ? 'Close' : 'Info'"
        style="opacity: 0; transform: translateY(50px)"
      />
    </div>

    <div
      class="extra"
      :style="{ display: toggle ? 'flex' : null }"
    >
      <Paragraph
        size="small"
        :text="translate('MENU_POLICY', $store.state.lang)"
        style="opacity: 0; transform: translateY(50px)"
      />
      <span style="opacity: 0;">.</span>
      <Paragraph
        size="small"
        :text="translate('MENU_COOKIE', $store.state.lang)"
        style="opacity: 0; transform: translateY(50px)"
      />
      <span style="opacity: 0;">.</span>
      <Paragraph
        size="small"
        text="<bdi>P.Iva  IT11817670018</bdi>"
        class="piva"
        style="opacity: 0; transform: translateY(50px)"
      />
    </div>

    <div
      class="copyright"
      :style="{ display: toggle ? 'block' : null }"
    >
      <Paragraph
        size="small"
        :text="copyright"
        style="opacity: 0; transform: translateY(50px)"
      />
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';

import translate from '@/assets/i18n';
import { transition } from '@/assets/animations';

import Title from '@/components/text/Title.vue';
import Paragraph from '@/components/text/Paragraph.vue';
import Counter from '@/components/text/Counter.vue';
import Breadcrumbs from '@/components/ui/Breadcrumbs.vue';

export default {
  name: 'Menu',

  components: {
    Title,
    Counter,
    Breadcrumbs,
    Paragraph,
  },

  data() {
    return {
      translate,
      toggle: false,
      menuInfoAnim: null,
      lang: {},
    };
  },

  computed: {
    ...mapGetters({
      routeName: 'getRouteName',
    }),

    links() {
      const data = this.$store.state.firebase;
      const s = {};
      const { lang } = this.$store.state;
      const pathLang = this.$store.state.lang === 'it' ? 'path' : 'pathEn';

      Object.keys(data).forEach((key) => {
        if (key !== 'home') {
          const link = `/${lang}${data[key][pathLang]}`;
          s[key] = link;
        }
      });

      return s;
    },
    copyright() {
      const year = new Date().getFullYear();
      const copy = window.innerWidth >= 768 ? 'Copyright' : '©';
      return `${copy} <span>.</span> ${year}`;
    },
  },

  watch: {
    routeName(n) {
      const data = this.$route.name === 'project' ? this.$store.state.firebase.investimenti.childrens : this.$route.name === 'person' ? this.$store.state.firebase.team.childrens : this.$store.state.firebase;
      const pathIt = this.$route.name === 'project' ? '/investimenti' : this.$route.name === 'person' ? '/team' : '';
      const pathEn = this.$route.name === 'project' ? '/investments' : this.$route.name === 'person' ? '/team' : '';

      this.lang = {
        it: {
          url: this.routeName !== 'home' ? `/it${pathIt}${data[this.routeName].path}` : '/it',
          label: 'Ita',
        },
        en: {
          url: this.routeName !== 'home' ? `/en${pathEn}${data[this.routeName].pathEn}` : '/en',
          label: 'Eng',
        },
      };
    },
  },

  methods: {
    toggleInfo() {
      this.toggle = !this.toggle;

      if (this.toggle) {
        if (this.menuInfoAnim === null) this.menuInfoAnim = transition.get('menu-info')(this.$el, this.toggle);

        this.menuInfoAnim.timeScale(1).play();
      } else {
        this.menuInfoAnim.timeScale(1.5).reverse();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  z-index: 19;

  visibility: hidden;
  pointer-events: none;

  a {
    position: absolute;
    pointer-events: none;
    h2 {
      // color: $color-primary;
      transition: all 0.5s ease-out;
      // line-height: 1em !important;
    }

    &:hover {
      h2 {
        opacity: 1 !important;
        visibility: visible !important;
      }

      .menu__counter {
        opacity: 1;
        transform: translate3d(-100%, 150%, 0);
      }

      .menu__line {
        opacity: 1;
        transform: translate3d(-100%, -20%, 0);

        &__inner {
          &--first {
            transform: translate3d(102%, 0, 0);
            transition-delay: 0s;
          }

          &--last {
            transform: translate3d(0%, 0, 0);
            transition-delay: .4s;
          }
        }
      }
    }

    &.active {
      cursor: default;

      h2 {
        opacity: 1 !important;
      }
    }
  }

  .menu {
    &__counter {
      position: absolute;
      top: 0;
      left: rem(-20px);

      width: rem(20px);
      height: rem(20px);

      display: none;

      @include mq(ipadP) {
        display: block;
        width: rem(30px);
      }

      @include mq(ds) {
        width: rem(60px);
      }

      opacity: 0;
      transform: translate3d(-100%, 200%, 0);

      text-align: right;

      transition: all 0.25s ease-out;
    }

    &__line {
      position: absolute;
      left: rem(-20px);
      bottom: 0;

      width: rem(20px);
      height: rem(20px);
      overflow: hidden;

      opacity: 0;
      transform: translate3d(-100%, 50%, 0);
      transition: all 0.25s ease-out 0.1s;
      display: none;

      @include mq(ipadP) {
        display: block;
        width: rem(30px);
      }

      @include mq(ds) {
        width: rem(60px);
      }

      &__inner {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: $color-dark-light;
        transition: transform .8s $outExpo;

        &--first {
          transform: translate3d(0%, 0, 0);

          transition-delay: .4s;
        }

        &--last {
          transform: translate3d(-102%, 0, 0);
        }
      }
    }
  }

  .lang {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-wrap: wrap;

    padding: 25px;

    @include mq(ipadP) {
      // height: 180px;
      padding: rem(40px);
    }

    @include mq(ds) {
      padding: rem(60px);
    }

    &--it {
      margin-right: 10px;
    }

    &--active {
      pointer-events: none;
      & > * {
        opacity: 0.5;
      }

      @include mq($until: ds, $from: ipadP) {
        display: none;
      }
    }

    & ::v-deep .p {
      font-size: rem(14px);
    }
  }

  .extra {
    position: absolute;
    bottom: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;

    padding: 25px 0;
    display: none;

    @include mq($until: ipadP) {
      & ::v-deep .p {
        font-size: rem(14px);
      }
    }

    @include mq(ipadP) {
      display: flex;
      // height: 180px;
      padding: rem(40px) 0;
    }

    @include mq(ds) {
      padding: rem(60px) 0;
    }

    span {
      display: inline-block;
      padding: 0 5px;

      @include mq(ipadP) {
        padding: 0 15px;
      }
    }
  }

  .copyright {
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;

    padding: 25px;

    & ::v-deep span {
      display: inline-block;
      padding: 0 5px;

      @include mq(ipadP) {
        padding: 0 15px;
      }
    }

    @include mq($until: ipadP) {
      & ::v-deep .p {
        font-size: rem(14px);
      }
    }

    display: none;

    @include mq(ipadP) {
      display: block;
      // height: 180px;
      padding: rem(40px);
    }

    @include mq(ds) {
      padding: rem(60px);
    }

  }

  .info {
    &__menu {
      position: absolute;
      bottom: 0;
      right: 0;
      padding: 25px;

      display: grid;
      grid-template-areas: 'b a';
      grid-template-rows: 1fr;
      column-gap: rem(20px);
      align-items: baseline;
      cursor: pointer;

      & ::v-deep .p {
        font-size: rem(14px);
      }

      @include mq(ipadP) {
        display: none;
      }
    }

    &__line {
      position: relative;
      width: rem(20px);
      height: 1px;
      overflow: hidden;

      @include mq(ipadP) {
        width: rem(30px);
      }

      @include mq(ds) {
        @at-root .breadcrumbs--medium & {
          width: rem(60px);
        }
      }

      &__inner {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: $color-dark-light;
        transition: transform .8s $outExpo;

        &--first {
          transform: translate3d(0%, 0, 0);

          transition-delay: .4s;
        }

        &--last {
          transform: translate3d(-102%, 0, 0);
        }
      }
    }

    &:hover
      .info__line__inner {
        &--first {
          transition-delay: 0s;
        }

        &--last {
          transform: translate3d(0%, 0, 0);
          transition-delay: .4s;
        }
      }
    }
}
</style>
